import React from 'react';
import PageLayout from '../components/PageLayout';
import { Button } from '../components/ui/button';
import { Download, FileText, Image, Mail } from 'lucide-react';

const PressKitPage = () => {
  return (
    <PageLayout title="Press Kit">
      <div className="space-y-8 text-slate-600">
        <section>
          <p className="text-lg">
            Thank you for your interest in SignalPath Digital Health Applications, LLC. Below you'll find 
            resources and information for media coverage. For press inquiries, please contact our communications team.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Company Overview</h2>
          <div className="bg-white p-6 rounded-xl border border-slate-200">
            <p className="mb-4">
              <strong>Company Name:</strong> SignalPath Digital Health Applications, LLC
            </p>
            <p className="mb-4">
              <strong>Founded:</strong> 2024
            </p>
            <p className="mb-4">
              <strong>Headquarters:</strong> United States
            </p>
            <p className="mb-4">
              <strong>Industry:</strong> Digital Health / Healthcare Technology
            </p>
            <p>
              <strong>Mission:</strong> Building a Stronger Future through Active Diabetes Care. We provide 
              a comprehensive diabetes management platform that connects glucose tracking, nutrition, fitness, 
              and mental wellness into one unified experience.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Brand Assets</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <Image className="h-8 w-8 text-emerald-500 mb-4" />
              <h3 className="font-manrope font-bold text-slate-900 mb-2">Logo Package</h3>
              <p className="text-sm mb-4">
                Download our logo in various formats (PNG, SVG, EPS) for web and print use.
              </p>
              <Button variant="outline" className="w-full">
                <Download className="h-4 w-4 mr-2" />
                Download Logos
              </Button>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <FileText className="h-8 w-8 text-emerald-500 mb-4" />
              <h3 className="font-manrope font-bold text-slate-900 mb-2">Brand Guidelines</h3>
              <p className="text-sm mb-4">
                Our brand guidelines including colors, typography, and usage rules.
              </p>
              <Button variant="outline" className="w-full">
                <Download className="h-4 w-4 mr-2" />
                Download Guidelines
              </Button>
            </div>
          </div>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">App Screenshots</h2>
          <p className="mb-4">
            High-resolution screenshots of our application are available for editorial use. Please contact 
            our press team for the most current imagery.
          </p>
          <Button variant="outline">
            <Download className="h-4 w-4 mr-2" />
            Request Screenshots
          </Button>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Boilerplate</h2>
          <div className="bg-slate-100 p-6 rounded-xl">
            <p className="italic">
              "SignalPath Digital Health Applications, LLC provides a comprehensive diabetes management 
              platform designed to empower individuals in their health journey. The app integrates glucose 
              tracking, nutrition logging, fitness monitoring, and mental wellness features into one unified 
              experience. By connecting daily health data into a clear, actionable narrative, SignalPath 
              helps users understand patterns, communicate effectively with healthcare providers, and build 
              stronger health habits. For more information, visit signalpathdigital.com."
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Press Contact</h2>
          <div className="bg-white p-6 rounded-xl border border-slate-200">
            <Mail className="h-8 w-8 text-emerald-500 mb-4" />
            <p className="mb-2">
              <strong>Media Relations</strong>
            </p>
            <p className="mb-4">
              For press inquiries, interview requests, or additional information:
            </p>
            <p className="text-emerald-600 font-medium">support@signalpathdigitalapps.com</p>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default PressKitPage;
